/**
 * Loads the FindOrCreateModule component to handle customer search and creation
 * Uses mediaQuery hook to determine viewport mode (mobile or desktop)
 */

import { offerSessionUtils } from '@makemydeal/dr-shared-ui-utils';
import { useOktaAuth } from '@okta/okta-react';
import { Suspense } from 'react';
import { FindOrCreateModule } from './FindOrCreateModule';
import { RemoteModuleErrorBoundary } from './RemoteModuleErrorBoundary';
import SalesCheckInSpinner from '../SalesCheckInSpinner/SalesCheckInSpinner';
import { useMediaQuery } from 'react-responsive';
import { BreakPoint } from '@makemydeal/dr-activities-common';
import type { CustomerSearchComponentProps } from '@makemydeal/dr-sales-checkin-types';
import { CUSTOMER_REQUIRED_FIELDS_FOR_PBC } from '@makemydeal/dr-sales-checkin-types';

export const CustomerSearch = ({ onCustomerSelected, commonOrgId }: CustomerSearchComponentProps) => {
    const isLargerThanSmall = useMediaQuery({ query: `(min-width: ${BreakPoint.SMALL})` });
    const viewportMode = isLargerThanSmall ? 'desktop' : 'mobile';
    const environment = offerSessionUtils.getEnvironmentType();
    const oktaContext = useOktaAuth();
    const getJwtToken = () => oktaContext?.oktaAuth.getAccessToken() || '';

    return (
        <RemoteModuleErrorBoundary moduleName="FindOrCreateModule">
            <Suspense fallback={<SalesCheckInSpinner />}>
                <FindOrCreateModule
                    onFindOrCreate={onCustomerSelected}
                    getAuthOverride={getJwtToken}
                    environment={environment}
                    dealershipId={commonOrgId}
                    viewportMode={viewportMode}
                    requiredFields={CUSTOMER_REQUIRED_FIELDS_FOR_PBC}
                />
            </Suspense>
        </RemoteModuleErrorBoundary>
    );
};
